/**
 * A custom cell renderer component for AG Grid that displays IMO number alongside a display value.
 *
 * This renderer leverages the ImoRenderer component to display vessel information in a grid cell.
 *
 * @param params - The standard AG Grid cell renderer props containing:
 *   - data: The row data object which should contain an imoNumber property
 *   - value: The cell value to be displayed
 *
 * @returns A React component rendering the IMO number with the display value
 *
 * @example
 * // In AG Grid column definition:
 * {
 *   field: 'vesselName',
 *   headerName: 'Vessel',
 *   cellRenderer: imoAndNameRenderer
 *   cellRendererParams: {
 *       // This is where you can pass additional parameters to the cell renderer if needed
 *       imoNumber: (params: any) => params.data.imoNumber,
 *   },
 * }
 */
import type { CustomCellRendererProps } from 'ag-grid-react';
import ImoRenderer from '../ImoRenderer';

export default (params: CustomCellRendererProps) => {

	if (!params || !params.data) {
		return null;
	}

	const { imoNumber } = params.data ? params.data : {};

	if (!imoNumber || isNaN(Number(imoNumber))) {
		// If imoNumber is not available or not a valid number, return null
		return null;
	}

	return <ImoRenderer imoNumber={Number(imoNumber)} displayValue={params.value} fromComponent={(params as any).fromComponent ?? ''} />;
};
